export default __webpack_public_path__ + "static/media/IC00044-account.c88cb9af.svg";